import { CellContext } from "@tanstack/react-table"

import { UITypes } from "types"

import CustomerNameContainer from "./CustomerNameContainer"

interface CustomerNameProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const CustomerName = ({ cell }: CustomerNameProps) => {
  const customerName = cell.getValue().value as string
  const customerId: number | null = cell.row.original.rowSettings.item.client_id
  const deviceSN: string | null = cell.row.original.rowSettings.item.sn || null
  const phisicalStatus = cell.row.original.rowSettings.item.phisical_status

  return (
    <CustomerNameContainer
      id={customerId}
      name={customerName}
      isInstalled={phisicalStatus === "installed"}
      deviceSN={deviceSN}
    />
  )
}
